export default function BigTerms(props) {
    return (
        <div className="text-black">
            <h4 className="font-bold text-3xl text-center py-16 border-b-4 border-t-4">Coastal Acquiring Processing Terms and Conditions</h4>
            <br></br>
            <h5 className="font-semibold text-2xl mb-2">VISA and Mastercard Disclosure</h5>
            <p className="text-lg mb-5">Coastal Acquiring Secure Holdings, LLC (Payment Facilitator), First Data
                Merchant Services
                LLC (Provider), and Pathward N.A. (Bank) (Payment Facilitator, Provider and Bank
                collectively we, us or our) will provide (Sub-Merchant, you or your) with certain Card
                processing services. Capitalized terms used in this Agreement are referred to in Appendix 1.
            </p>

            <p className="text-lg mb-5"> By entering into this Sub-Merchant Processing Agreement (the
                Agreement), you agree to comply
                with the (1) Network Rules as they pertain to Card information you receive through the
                Payment Facilitator service and (2) Your Payments Acceptance Guide.</p>

            <p className="text-lg mb-5"> Bank and Provider are party to this Agreement for the purpose of
                facilitating funding of
                amounts owed for properly submitted transactions, less amounts owed to us under this
                Agreement. As such, you waive any and all claims for damages against Bank and Provider
                arising from or related to this Agreement. Nothing in this paragraph will limit the
                rights
                and remedies available to Bank or Provider in this Agreement.</p>

            <h5 className="font-semibold text-2xl mb-2">Acceptace of Cards</h5>
            <p className="text-lg mb-5">
                You agree to comply with Your Payments Acceptance Guide and all Network Rules, as such
                may be
                changed from time to time. You understand that we may be required to modify Your
                Payments
                Acceptance Guide and the Agreement from time to time in order to comply with
                requirements
                imposed by the Networks.
            </p>

            <p className="text-lg mb-5">
                In offering payment options to your customers, you may elect any one of the following
                options:
                (1) Accept all types of Visa and Mastercard cards, including consumer credit and
                debit/check
                cards, and commercial credit and debit/check cards; (2) Accept only Visa and Mastercard
                credit
                cards and commercial cards (If you select this option, you must accept all consumer
                credit cards
                (but not consumer debit/check cards) and all commercial card products, including
                business
                debit/check cards); or (3) Accept only Visa and Mastercard consumer debit/check cards
                (If you
                select this option, you must accept all consumer debit/check card products (but not
                business
                debit/check cards) and refuse to accept any kind of credit cards). The acceptance
                options above
                apply only to domestic transactions.
            </p>

            <p className="text-lg mb-5">
                If you choose to limit the types of Visa and Mastercard cards you accept, you must
                display
                appropriate signage to indicate acceptance of the limited acceptance category you have
                selected
                (that is, accept only debit/check card products or only credit and commercial products).
            </p>

            <p className="text-lg mb-5">
                For recurring transactions, you must obtain a written request or similar authentication
                from
                your customer for the goods and/or services to be charged to the customer’s account,
                specifying
                the frequency of the recurring charge and the duration of time during which such charges
                may be
                made.
            </p>

            <h5 className="font-semibold text-2xl mb-2">Settlement</h5>

            <p className="text-lg mb-5">
                Upon our receipt of the Transaction Data for Card transactions, we will process the
                Transaction Data to facilitate the funds transfer from the various Networks for the Card
                sales. After we receive credit for such Transaction Data, subject to our other rights
                under
                this Agreement, we will provide provisional credit to your Settlement Account.
            </p>


            <p className="text-lg mb-5">
                You must not submit transactions for payment until the goods are delivered shipped, or
                the
                services are performed. If the Cardholder disputes being charged for merchandise or
                services
                before receiving them, a Chargeback may result.
            </p>

            <h5 className="font-semibold text-2xl mb-2">Chargebacks</h5>

            <p className="text-lg mb-5">
                Sub-Merchant is solely responsible to pay the amount of any Chargebacks resulting from
                Transactions submitted by Sub-Merchant under this Agreement. Chargebacks can be received
                for
                a number of reasons. The following are some of the most common reasons for Chargebacks:
                (1)
                a refund is not issued to a customer upon the return or non-delivery of goods or
                services;
                (2) an authorization/approval code was required and not obtained; (3) the transaction
                was
                allegedly fraudulent; (4) the customer disputes the Card sale or the signature on the
                sale
                documentation, or claims that the sale is subject to a set-off, defense or counterclaim;
                or
                (5) The customer refuses to make payment for a Card sale because in the customer's good
                faith opinion, a claim or complaint has not been resolved, or has been resolved but in
                an
                unsatisfactory manner.
            </p>

            <h5 className="font-semibold text-2xl mb-2">Fees</h5>

            <p className="text-lg mb-5">
                Pursuant to Appendix 2, you agree to pay Payment Facilitator the fees associated with
                the
                provision of the services contemplated hereunder.
            </p>

            <h5 className="font-semibold text-2xl mb-2">Reserve</h5>

            <p className="text-lg mb-5">
                You acknowledge that in addition to any other rights afforded us hereunder, we may
                establish
                a reserve account to satisfy your obligations or potential obligations under this
                Agreement
                (the Reserve), which may be funded by: (i) our demand and your immediate payment for
                such
                amounts; (ii) our debiting the account identified as the Settlement Account; (iii) our
                withholding your settlement payments until all amounts are paid, (iv) our delaying
                presentation of your refunds until you make a payment to us of a sufficient amount to
                cover
                the Reserve; and (v) our pursuit of any remedies we may have at law or in equity.
            </p>

            <p className="text-lg mb-5">
                The Reserve will contain sufficient funds to cover any unbilled processing costs plus
                our
                estimated exposure based on reasonable criteria for Chargebacks, fines, returns and
                unshipped merchandise and/or unfulfilled services. We may (but are not required to)
                apply
                funds in the Reserve toward, and may set off any funds that would otherwise be payable
                to
                you against, the satisfaction of any amounts which are or become due from you pursuant
                to
                this Agreement.
            </p>

            <p className="text-lg mb-5">
                The Reserve will not bear interest, and you will have no right or interest in the funds
                in
                the Reserve; provided that upon satisfaction of all of your obligations under this
                Agreement, we will pay to you any funds then remaining in the Reserve. Any funds in the
                Reserve may be commingled with other funds, and need not be maintained in a separate
                account. Effective upon our establishment of a Reserve, you irrevocably grant to us a
                security interest in any and all funds, together with the proceeds thereof, that may at
                any
                time be in our possession and would otherwise be payable to you pursuant to the terms of
                this Agreement. You agree to execute and deliver to us such instruments and documents
                that
                we may reasonably request to perfect and confirm the security interest and right of
                setoff
                set forth in this Agreement. The parties’ rights and obligations under this Section
                shall
                survive termination of this Agreement.
            </p>

            <h5 className="font-semibold text-2xl mb-2">Financial Information</h5>

            <p className="text-lg mb-5">
                Upon request, you will promptly provide us with any necessary permissions or consents,
                financial statements or other information reasonably requested by us to perform credit
                risk,
                security, qualification, and other reviews related to the provision of the Services,
                transactions submitted, fulfillment of obligations to us or Cardholders, or your
                financial
                condition. You authorize us and our processor to obtain information from third parties
                when
                performing credit risk, security, qualification, and other reviews We, our processor or
                Bank
                may perform a reasonable audit of the your records related to its performance under this
                Agreement with 30 days’ advance written notice to you, during your normal business
                hours.
                Financial statements shall be prepared in accordance with generally accepted accounting
                principles. You will also provide other information concerning your business and your
                compliance with the terms and provisions of this Agreement as we may reasonably request.
            </p>

            <h5 className="font-semibold text-2xl mb-2">Data Security and Privacy</h5>

            <p className="text-lg mb-5">
                You represent to us that you do not have access to Card information (such as the
                cardholder’s account number, expiration date, and CVV2) and you will not request access
                to
                such Card information from us. In the event that you receive such Card information in
                connection with the acceptance or submittal of Card Transactions provided under this
                Agreement, you agree that you will not use it for any fraudulent purpose or in violation
                of
                any Network Rules, including but not limited to Payment Card Industry Data Security
                Standards (PCI DSS) or applicable law. If at any time you believe that Card information
                has
                been compromised, you must notify us promptly and assist in providing notification to
                the
                proper parties. You must ensure your compliance and that of any third party service
                provider
                utilized by you, with all security standards and guidelines that are applicable to you
                and
                published from time to time by Visa, Mastercard or any other Network, including, without
                limitation, the Visa U.S.A. Cardholder Information Security Program (CISP), the
                Mastercard
                Site Data Protection (SDP), and (where applicable), the PCI Security Standards Council,
                Visa, and Mastercard PA-DSS (Payment Application Data Security Standards) (collectively,
                the
                Security Guidelines). If any Network requires an audit of you due to a data security
                compromise event or suspected event, you agree to cooperate with such audit. You may not
                use
                any Card information other than for the sole purpose of completing the Transaction
                authorized by the customer for which the information was provided to you, or as
                specifically
                allowed by Network Rules, Your Payments Acceptance Guide or required by law.
            </p>

            <h5 className="font-semibold text-2xl mb-2">Term; Events of Default</h5>

            <p className="text-lg mb-5">
                This Agreement shall be in effect upon signing by of each document by all parties and
                shall
                remain effective through the initial term of _________ years and shall thereafter
                automatically continue until terminated by either party upon the provision of thirty
                (30)
                days’ notice to the other party.
            </p>


            <p className="text-lg mb-5">
                If any of the following events shall occur (each an Event of Default):
            </p>


            <p className="text-lg mb-5">
                1. a material adverse change in your business, financial condition, business procedures,
                prospects, products or services; or
            </p>


            <p className="text-lg mb-5">
                1. any assignment or transfer of voting control of you or your parent; or
            </p>


            <p className="text-lg mb-5">
                1. a sale of all or a substantial portion of your assets; or
            </p>


            <p className="text-lg mb-5">
                1. irregular Card sales by you, excessive Chargebacks, noncompliance with any applicable
                data
                security standards, as determined by us, of any Network, or any other entity, or an
                actual
                or suspected data security breach, or any other circumstances which, in our sole
                discretion,
                may increase our exposure for your Chargebacks or otherwise present a financial or
                security
                risk to us; or
            </p>

            <p className="text-lg mb-5">
                1. any of your conditions, covenants, obligations or representations or warranties in
                this
                Agreement are breached in any material respect or are incorrect in any material respect
                when
                made or deemed to be made; or
            </p>

            <p className="text-lg mb-5">
                1. you shall file a petition or have a petition filed by another party under the
                Bankruptcy
                Code or any other laws relating to bankruptcy, insolvency or similar arrangement for
                adjustment of debts; consent to or fail to contest in a timely and appropriate manner
                any
                petition filed against you in an involuntary case under such laws; apply for or consent
                to,
                or fail to contest in a timely and appropriate manner, the appointment of, or the taking
                of
                possession by, a receiver, custodian, trustee or liquidator of itself or of a
                substantial
                part of its property; or make a general assignment for the benefit of creditors; or take
                any
                corporate action for the purpose of authorizing any of the foregoing; or
            </p>

            <p className="text-lg mb-5">
                1. a violation by you of any applicable law or Network Rule or our reasonable belief
                that
                termination of this Agreement or suspension of services is necessary to comply with any
                law
                including without limitation the rules and regulations promulgated by the Office of
                Foreign
                Assets Control of the US Department of the Treasury or your breach, as determined by
                Servicers, of your requirement to comply with all applicable laws. T
            </p>

            <p className="text-lg mb-5">
                then, upon the occurrence of (1) an Event of Default specified in subsections (iv),
                (vi),
                (vii), or (viii) we may consider this Agreement to be terminated immediately, without
                notice, and all amounts payable hereunder shall be immediately due and payable in full
                without demand or other notice of any kind, all of which are expressly waived by you,
                and
                (2) any other Event of Default, this Agreement may be terminated by us giving not less
                than
                10 days’ notice to you, and upon such notice all amounts payable hereunder shall be due
                and
                payable on demand.
            </p>

            <p className="text-lg mb-5">
                Neither the expiration nor termination of this Agreement shall terminate the obligations
                and
                rights of the parties pursuant to provisions of this Agreement which by their terms are
                intended to survive or be perpetual or irrevocable. Such provisions shall survive the
                expiration or termination of this Agreement. All obligations by you to pay or reimburse
                us
                for any obligations associated with transactions you have submitted to us are intended
                to
                survive termination of this Agreement.
            </p>

            <p className="text-lg mb-5">
                If any Event of Default shall have occurred and regardless of whether such Event of
                Default
                has been cured, we may, in our sole discretion, exercise all of our rights and remedies
                under applicable law, and this Agreement.
            </p>

            <p className="text-lg mb-5">
                The Networks often maintain lists of merchants who have had their merchant agreements or
                Card acceptance rights terminated for cause. If this Agreement is terminated for cause,
                you
                acknowledge that we may be required to report your business name and the names and other
                information regarding its principals to the Networks for inclusion on such list(s). You
                expressly agree and consent to such reporting if you are terminated as a result of the
                occurrence of an Event of Default or for any reason specified as cause by the Networks.
                Furthermore, you agree to waive and hold us harmless from and against any and all claims
                which you may have as a result of such reporting.
            </p>

            <p className="text-lg mb-5">
                In the event we provide notice to you of an increase in the fees for Services, you may
                terminate this Agreement without further cause or penalty by providing us 30 days
                advance
                written notice of termination. You must terminate within 30 days after we provide notice
                of
                the fee increase. However, maintaining your account with us or your continued use of our
                Services after the effective date of any increase shall be deemed acceptance of the
                increased fees for Services, throughout the term of this Agreement.
            </p>

            <p className="text-lg mb-5">
                We may terminate this Agreement at any time and for any or no reason upon the provision
                of
                thirty (30) days prior notice. We may also temporarily suspend or delay payments to you
                during our investigation of any issue and/or designate an amount of funds that we must
                maintain in order to protect us against the risk of, among other things, existing,
                potential, or anticipated Chargebacks arising under this Agreement or other amounts that
                may
                be owing to us under this Agreement.
            </p>

            <p className="text-lg mb-5">
                Warranties; Exclusion of Consequential Damages; Limitation on Liability
            </p>

            <p className="text-lg mb-5">
                This Agreement and any addenda is an agreement for services and except as expressly
                provided
                in this Agreement, and any addenda, we and our affiliates disclaim all representations
                or
                warranties, express or implied, made to merchant or any other person, including without
                limitation, any warranties regarding quality, suitability, merchantability, fitness for
                a
                particular purpose or otherwise (regardless of any course of dealing, custom or usage of
                trade) of any services or any goods provided incidental to the Services provided under
                this
                Agreement.
            </p>
            <p className="text-lg mb-5">
                Notwithstanding anything in this in this Agreement and any addenda to the contrary, in
                no
                event shall we or our affiliates be liable under any theory of tort, contract, strict
                liability or other legal theory for lost profits, lost revenues, lost business
                opportunities, exemplary, punitive, special, incidental, indirect or consequential
                damages,
                each of which is hereby excluded by agreement of the parties, regardless of whether such
                damages were foreseeable or whether any party or any entity has been advised of the
                possibility of such damages.
            </p>

            <p className="text-lg mb-5">
                Notwithstanding anything in this Agreement and any addenda to the contrary, we and our
                affiliates’ cumulative liability, in the aggregate (inclusive of any and all claims made
                by
                Sub-Merchant against us and/or our affiliates, whether related or unrelated) for all
                losses,
                claims, suits, controversies, breaches, or damages for any cause whatsoever (including,
                but
                not limited to, those arising out of or related to this Agreement any addenda) and
                regardless of the form of action or legal theory shall not exceed the lesser of (i)
                $100,000; or (ii) the amount of fees received by us pursuant to any addenda attached and
                incorporated herein for services performed in the immediately preceding 12 months.
            </p>

            <h5 className="font-semibold text-2xl mb-2">Confidentiality</h5>

            <p className="text-lg mb-5">Each party acknowledges and agrees that the other may be providing to
                it and that it may
                become aware of the confidential and proprietary information of the other party,
                including but not limited to, the terms of this Agreement, financial information and
                other information related to each party’s business operations. Each party agrees that it
                will maintain the confidentiality of such information and neither party shall disclose
                any such information to any other person or entity (other than to those of its
                employees, agents, contractors, representatives and Affiliates to whom disclosure is
                reasonably necessary in furtherance of the performance of this Agreement).
                Notwithstanding the foregoing, the requirements of non-disclosure shall not apply to any
                information which: (a) at the time of disclosure is already in the possession of the
                receiving party; (b) is independently developed by the receiving party without reliance
                on the disclosed confidential or proprietary information; (c) is or becomes publicly
                available through no wrongdoing of the receiving party or (d) becomes available to
                receiving party on a non-confidential basis from a person, other than the disclosing
                party, who is not bound by a confidentiality obligation or otherwise restricted from
                transmitting the information to the receiving party. Furthermore, this section shall not
                prohibit the receiving party from making legally required disclosures pursuant to
                subpoena, court order or the order of any other authority having jurisdiction; provided
                that receiving party shall provide disclosing party with prompt notice, unless
                prohibited by law or court order, thereof so that disclosing party may seek an
                appropriate protective order or other remedy. If in the absence of a protective order or
                other remedy or waiver of the terms of this section, if receiving party determines in
                its sole discretion that it is required by law, regulation, legal process or regulatory
                authority to disclose any such confidential or proprietary information, receiving party
                may disclose such information upon written notice to disclosing party unless prohibited
                by law or court order..</p>

            <p className="text-lg mb-5">Member Bank Name: Pathward N.A.

                Bank mailing address: 5501 S. Broadband Lane, Sioux Falls, SD 57108

                Bank Phone Number: 1-866-550-6382</p>

            <h5 className="font-semibold text-2xl mb-2">Important Member Bank Responsibilities</h5>

            <p className="text-lg mb-5">(a) The Bank is the only entity approved to extend acceptance of Visa
                and Mastercard
                products directly to a merchant.</p>



            <p className="text-lg mb-5">(b) The Bank must be a principal (signer) to the Sub-Merchant
                Agreement.</p>



            <p className="text-lg mb-5">(c) The Bank is responsible for educating Sub-Merchants on pertinent
                Visa and Mastercard
                Rules with which Sub-Merchants must comply; but this information may be provided to you
                by
                Payment Facilitator.</p>



            <p className="text-lg mb-5">(d) The Bank is responsible for and must provide settlement funds to
                the Payment
                Facilitator, for distribution to the Sub-Merchant.</p>



            <p className="text-lg mb-5">(e) The Bank is responsible for all funds held in reserve at Bank that
                are derived from
                settlement.</p>

            <h5 className="font-semibold text-2xl mb-2">Important Sub-Merchant Responsibilities</h5>

            <p className="text-lg mb-5">
                (a) In the event Sub-Merchant obtains Card Information, ensure compliance with
                Cardholder
                data security and storage requirements.
            </p>

            <p className="text-lg mb-5">
                (b) Maintain fraud and chargebacks below Network thresholds.
            </p>

            <p className="text-lg mb-5">
                (c) Review and understand the terms of the Agreement.
            </p>

            <p className="text-lg mb-5">
                (d) Comply with Network Rules.
            </p>

            <p className="text-lg mb-5">
                (e) Retain a signed copy of this Disclosures Page.
            </p>


            {/* <!-- American Express Legal Start --> */}
            <h5 className="font-semibold text-2xl mb-2">American Express OptBlue® Program Terms and Conditions</h5>

            <p className="text-lg mb-5">
                1. Amex Services. These American Express OptBlue Program Terms (Amex Terms) describe
                some of
                the requirements for your acceptance of American Express Cards under the American
                Express
                OptBlue Program (OptBlue Program). You agree that your acceptance of American Express
                Cards
                will comply with the Agreement and with the American Express Merchant Operating Guide
                (Amex
                Guide) which are the Rules for American Express Card Transactions. The Amex Guide
                applies
                only to American Express Card Transactions and the American Express OptBlue Program.
                Capitalized words and phrases that are used but not defined under Certain Definitions
                below
                or elsewhere in the Agreement are defined in the Amex Guide, which is available to you
                at
                www.americanexpress.com/merchantopguide. If these Amex Terms conflict with any other
                part of
                the Agreement with respect to American Express Card Transaction, these Amex Terms will
                control. The acquiring services (including Authorization, processing, and settlement)
                that
                you receive for your American Express Card Transactions (Amex Services) are provided by
                Payment Facilitator through a separate agreement with a third-party processor and not by
                Bank.
            </p>

            <p className="text-lg mb-5">
                2. Definitions. The defined words and phrases below apply only to these Amex Terms and
                American Express Card Transactions. Any terms not defined here or in the Amex Guide will
                have the meaning given to them in the Agreement.
            </p>

            <p className="text-lg mb-5">
                American Express Card or Card means (a) any card, account access device, or payment
                device
                or service bearing American Express or American Express Affiliates’ Marks and issued by
                an
                Issuer, or (b) a Card number issued by an Issuer which can be used to purchase goods or
                services from you.
            </p>


            <p className="text-lg mb-5">
                American Express means American Express Travel Related Services Company, Inc., a New
                York
                corporation.
            </p>

            <p className="text-lg mb-5">
                American Express Brand means the Marks of American Express and its affiliates.
            </p>

            <p className="text-lg mb-5">
                Amex Transaction Data means all information required by American Express evidencing one
                or
                more transactions, including information obtained at the point of sale, information
                obtained
                or generated during authorization and submission, and any Chargeback.
            </p>

            <p className="text-lg mb-5">
                Applicable Law means (a) any law, statute, regulation, ordinance, or subordinate
                legislation
                in force from time to time to which you or Processor is subject, (b) the common law as
                applicable to them from time to time, (c) any court order, judgment, or decree that is
                binding on them, and (d) any directive, policy, rule, or order that is binding on them
                and
                that is made or given by a regulator or other government agency of the United States (or
                any
                of its territories) or any other federal, commonwealth, state, provincial, or local
                jurisdiction. References to “Law” elsewhere in the Agreement include this definition but
                only for purposes of the Amex Services and American Express Card Transactions.
            </p>

            <p className="text-lg mb-5">
                Card Member means an individual or Entity (a) that has entered into an agreement
                establishing a Card account with an Issuer, or (b) whose name appears on the Card.
                References to a “cardholder” elsewhere in the Agreement include this definition but only
                for
                purposes of the Amex Services and American Express Card Transactions.
            </p>

            <p className="text-lg mb-5">
                Charge means a payment or purchase made on the Card.
            </p>

            <p className="text-lg mb-5">
                Establishments means any or all of your (or your Affiliates’) locations, outlets,
                websites,
                online networks, and all other methods for selling goods and services, including methods
                that you adopt in the future. References to “locations” elsewhere in the Agreement
                include
                this definition but only for purposes of the Amex Services and American Express Card
                Transactions.
            </p>

            <p className="text-lg mb-5">
                Transaction means a Charge or Credit completed by the means of a Card.
            </p>

            <p className="text-lg mb-5">
                3. Amex Services: Qualification Criteria and Merchant Operating Guide.
            </p>

            <p className="text-lg mb-5">
                3.1. If you meet the criteria below and elect to accept American Express Transactions,
                we
                will provide Amex Services to you under the terms and settlement time frames provided in
                your Agreement.
            </p>

            <p className="text-lg mb-5">
                3.2. To qualify for the Amex Services, you must meet the following criteria: (a) your
                Total
                Annual American Express volume is less than $1,000,000; (b) your business is not of a
                merchant category type prohibited by American Express; and (c) you are not a franchisee
                of
                any franchise excluded by American Express from eligibility for the OptBlue Program.
            </p>


            <p className="text-lg mb-5">
                3.3. After initial qualification, you must continue to meet American Express’s criteria
                for
                the OptBlue Program. Currently, these criteria (each, a Continuing Qualification
                Threshold)
                are: (a) the total volume of American Express Card Transactions in any rolling 12-month
                period for all your Establishments is not more than $1,000,000, and (b) the total
                monthly
                volume of American Express Card Transactions for all your Establishments for any 3
                consecutive months does not exceed $100,000 per month.
            </p>


            <p className="text-lg mb-5">
                3.4. If you fail to meet the Continuing Qualification Thresholds, we may notify you of
                your
                conversion to a direct American Express Card acceptance relationship with American
                Express.
                In this event, you agree that once this conversion occurs (a) you will be bound by
                American
                Express’s then-current Card Acceptance Agreement with respect to American Express
                Transactions, (b) American Express will set pricing and other fees payable by you for
                American Express Card acceptance, and (c) you will no longer be able to participate in
                the
                OptBlue Program through us. However, we may continue to provide authorization and
                processing
                services, but not settlement services, to you for your American Express Card
                Transactions
            </p>


            <p className="text-lg mb-5">
                4. Fees for Amex Services. [IC+ all American Express Card fees on a straight pass-thru
                basis
                plus $0.__/transaction plus __ bps].
            </p>

            <p className="text-lg mb-5">
                5. American Express Transaction Data. The Amex Transaction Data you are required to
                collect
                in connection with a Transaction must be provided directly to you by the American
                Express
                Card Member. You must not accept Amex Transaction Data from, nor are you permitted to
                provide Amex Transaction Data to, any third parties other than your covered parties (as
                defined in the Data Security Operating Policy). If you fail to comply with this
                requirement,
                in addition to other rights and remedies regarding “monitoring,” you may be charged a
                fee as
                indicated in the American Express Program Pricing Guide, and we may suspend Card
                acceptance
                privileges at your Establishments or terminate the Agreement. For Card Member
                Transactions
                involving payment or “e-wallet” accounts (which Card Member created by providing their
                information when the account was established), the necessary Amex Transaction Data has
                already been provided directly by the Card Member, and you are not required to have the
                Card
                Member re-enter the Amex Transaction Data.
            </p>

            <p className="text-lg mb-5">
                Disclosure and Use of Data Collected Under Agreement. We may disclose to American
                Express
                all data and information you provide that we collect as part of performing any Amex
                Service
                or any other Service related to your American Express Card Transactions (Collected
                Data).
                American Express may use and share Collected Data (a) to screen and/or monitor you in
                connection with Card marketing and administrative purposes, (b) to perform its
                responsibilities in connection with your acceptance of American Express Cards, (c) to
                promote the American Express Network, (d) to perform analytics and create reports, and
                (e)
                for any other business purpose, including marketing, as permitted by Applicable Law.
                American Express uses reasonable administrative, technical, and physical security
                measures
                to protect your information, consistent with the sensitivity of the information.
            </p>

            <p className="text-lg mb-5">
                6. Consent for American Express to Contact You by Phone, e-Mail, Text, or Fax. American
                Express may use the information under About You (or that you update from time to time)
                to
                call you or send you communications or materials via email, text, fax, or other
                electronic
                means about American Express services and resources available to you. You consent to
                receive
                auto-dialed, automated, or pre-recorded calls or communications (including text
                messages) at
                the telephone number(s) you have provided. If you provide a fax number, you consent to
                receive fax communications from American Express. You acknowledge that by giving these
                consents, the calls made to you or the communications sent to you by American Express
                may be
                subject to charges or fees by your telecommunications or other applicable service First
                Data, and you agree that any charges or fees are your responsibility to pay. You also
                acknowledge that these consents are not a condition of receiving Amex Services.
            </p>

            <p className="text-lg mb-5">
                7. Opt-Out. You may opt out of receiving marketing-related communications and materials
                from
                American Express
            </p>


            <p className="text-lg mb-5">
                by providing notice to Provider as set forth in Section 18 of the Agreement in the
                Agreement. If you have opted out, you may still receive messages or communications from
                American Express related to important information about the Amex Services or other
                American
                Express products, services, and resources available to you.
            </p>

            <p className="text-lg mb-5">
                8. No Assignment of Payments. You agree not to assign to any third party any payments
                due to
                you under the Agreement as the result of American Express Card Transactions, and all
                indebtedness arising from Charges will be for bona fide sales of goods and/or services
                at
                your Establishments free of liens, claims, and encumbrances (other than ordinary sales
                taxes). You may, however, sell and assign future Transaction receivables to Processor or
                to
                any other funding source that partner with Processor.
            </p>

            <p className="text-lg mb-5">
                9. Third Party Beneficiary Rights. American Express is a direct and intended third party
                beneficiary of the Agreement (including these Amex Terms) and may enforce any terms of
                the
                Agreement that apply to American Express, including American Express Card acceptance and
                transaction processing, directly against you.
            </p>

            <p className="text-lg mb-5">
                10. Your Right to Opt Out of American Express Card Acceptance. You may opt out of
                accepting
                American Express Cards at any time without affecting your right to accept any other
                payment
                type Processor supports.
            </p>
            <p className="text-lg mb-5">
                11. Collections from American Express Card Members. You may not bill or collect from any
                American Express Card Member for any purchase or payment on the American Express Card
                unless
                Chargeback has been exercised, you have fully paid for the Charge, and you otherwise
                have
                the right to do so.
            </p>

            <p className="text-lg mb-5">
                12. American Express Excessive Disputes. You may be subject to various fees and
                assessments
                as set forth in the Schedule of Fees or in the American Express Program Pricing Guide,
                including fees for excessive disputes. Some fees and assessments are for special
                products or
                services, while others may be applied based upon non-compliance with American Express
                policies and procedures. Many non-compliance fees and assessments can be avoided by
                correcting the actions that are causing the non-compliance.
            </p>

            <p className="text-lg mb-5">
                13. American Express Right to Modify or Terminate Agreement. American Express has the
                right
                to modify the Network Rules with respect to American Express Card Transactions or to
                terminate your acceptance of American Express Card Transactions and to require us or the
                Provider to investigate your activities with respect to American Express Card
                Transactions.
                Upon termination for any reason, you must immediately remove American Express licensed
                marks
                from your website and wherever else they are displayed upon termination or upon your
                termination from the Amex Services.
            </p>

            <h5 className="font-semibold text-2xl mb-2">American Express OptBlue® Schedule</h5>

            <p className="text-lg mb-5">
                The American Express OptBlue® Program (American Express Card Acceptance), transactions
                processed, and other matters contemplated under this Schedule are subject to the
                Agreement,
                as applicable, except to the extent the terms of this Schedule directly conflicts with
                another provision the Agreement, in which case the terms of this Schedule will control.
            </p>


            <p className="text-lg mb-5">
                Definitions. Capitalized words used in this Schedule that are not otherwise defined
                herein
                will have the meaning given to them in the Agreement.
            </p>


            <p className="text-lg mb-5">
                American Express Card or Card means (a) any card, account access device, or payment
                device
                or service bearing American Express or American Express Affiliates’ Marks and issued by
                an
                Issuer, or (b) a Card number issued by an Issuer which can be used to purchase goods or
                services from you.
            </p>


            <p className="text-lg mb-5">
                American Express means American Express Travel Related Services Company, Inc., a New
                York
                corporation.
            </p>


            <p className="text-lg mb-5">
                American Express Brand means the Marks of American Express and its affiliates.
            </p>


            <p className="text-lg mb-5">
                Amex Transaction Data means all information required by American Express evidencing one
                or
                more transactions, including information obtained at the point of sale, information
                obtained
                or generated during Authorization and Submission, and any Chargeback.
            </p>


            <p className="text-lg mb-5">
                Applicable Law means (a) any law, statute, regulation, ordinance, or subordinate
                legislation
                in force from time to time to which you or First Data is subject, (b) the common law as
                applicable to them from time to time, (c) any court order, judgment, or decree that is
                binding on them, and (d) any directive, policy, rule, or order that is binding on them
                and
                that is made or given by a regulator or other government or government agency of the
                United
                States (or any of its territories), or federal, commonwealth, state, provincial, or
                local
                jurisdiction. References to “Law” elsewhere in the Agreement include this definition but
                only for purposes of the American Express Card Acceptance Services and American Express
                Card
                Transactions.
            </p>

            <p className="text-lg mb-5">
                Card Member means an individual or Entity (a) that has entered into an agreement
                establishing a Card account with an Issuer, or (b) whose name appears on the Card.
                References to a “cardholder” elsewhere in the Agreement include this definition but only
                for
                purposes of the American Express Card Acceptance Services and American Express Card
                Transactions.
            </p>


            <p className="text-lg mb-5">
                Network references to Network elsewhere in the Agreement for purposes of American
                Express
                Card Acceptance Services and American Express Transactions shall be read to include
                American
                Express.
            </p>


            <p className="text-lg mb-5">
                Charge means a payment or purchase made on the Card.
            </p>

            <p className="text-lg mb-5">
                Establishments means any or all of your (or your Affiliates’) locations, outlets,
                websites,
                online networks, and all other methods for selling goods and services, including methods
                that you adopt in the future. References to “locations” elsewhere in the Agreement
                include
                this definition but only for purposes of the American Express Card Acceptance Services
                and
                American Express Card Transactions.
            </p>


            <p className="text-lg mb-5">
                Transaction means a Charge or Credit completed by the means of a Card.
            </p>


            <p className="text-lg mb-5">
                Services. The acquiring services (including authorization, processing, and settlement)
                that
                you receive for your American Express Card Transactions (American Express Card
                Acceptance
                Services) are provided by First Data and not by Bank. The parties acknowledge and agree
                that
                Bank is not a party to this Schedule insofar as it applies to the American Express Card
                Acceptance Services, and Bank is not liable to you in any way with respect to such
                American
                Express Card Acceptance Services.
            </p>


            <p className="text-lg mb-5">
                3. Compliance with American Express Rules and the American Express Operating Guide.
            </p>

            <p className="text-lg mb-5">
                3.1 You agree that your acceptance of American Express Cards will comply with the
                policies
                and procedures set forth in this Schedule, the American Express OptBlue Program
                Operating
                Regulations (OptBlue Regulations), and the American Express Merchant Operating Guide
                (Amex
                Guide) which sets forth the rules for American Express Card Transactions (Amex Rules),
                as
                may be amended by American Express. The then-current version of the Amex Rules is
                available
                to you at www.americanexpress.com/merchantopguide.
            </p>


            <p className="text-lg mb-5">
                3.2 You agree that each agreement you enter into with a Sub-Merchant will comply with
                the
                policies and procedures set forth in this Schedule, the American Express OptBlue Program
                Operating Regulations, and the Amex Guide, including the requirement that you must have
                the
                right to immediately terminate an agreement with any Sub-Merchant for cause or
                fraudulent
                activity, or otherwise upon American Express' request.
            </p>


            <p className="text-lg mb-5">
                3.3 You may not discriminate against the Card by charging Sub-Merchants higher or
                additional
                fees or assessments (or both) for such service than what you would charge Sub-Merchants
                for
                similar services you provide to merchants for other payment products. Any such fees or
                assessments must not be prohibited by Applicable Law.
            </p>


            <p className="text-lg mb-5">
                3.4 You may not sign an agreement for American Express Card Acceptance with any
                Sub-Merchant
                that (i) is not using You to process other transactions through First Data, or (ii) is
                itself a payment facilitator.
            </p>


            <p className="text-lg mb-5">
                3.5 You agree to assume financial liability for all settlement activity on behalf of
                your
                Sub-Merchants, including Chargebacks and Credits, as defined in the Amex Guide. You are
                also
                liable for all other acts, omissions, and Card Member customer service-related issues
                caused
                by your Sub-Merchants. Neither you nor your Sub-Merchants may transfer such financial
                liability by asking or requiring Card Members to waive their dispute rights.
            </p>


            <p className="text-lg mb-5">
                3.6 You shall (i) perform appropriate background and verification checks, credit checks,
                "know your customer", and anti-money laundering checks of all your Sub-Merchants and
                their
                respective significant owners (any person who has 25% or greater ownership of a
                Sub-Merchant) and/or authorized signer(s) in accordance with Applicable Laws and
                otherwise
                as American Express may require, and (ii) provide American Express, on request, copies
                of
                policies governing these checks and otherwise respond to American Express' requests
                about
                performance of these checks.
            </p>


            <p className="text-lg mb-5">
                4. Term and Termination.
            </p>

            <p className="text-lg mb-5">
                4.1 The American Express Card Acceptance Services being provided under this Schedule
                shall
                be coterminous with and as set forth in the Agreement.
            </p>

            <p className="text-lg mb-5">
                4.2 In addition to the termination rights set forth in the Agreement, American Express
                has
                the right to modify Network Rules with respect to American Express Card Transactions or
                to
                terminate your acceptance of American Express Card Transactions and to require First
                Data to
                investigate your activities with respect to American Express Card Transactions.
            </p>


            <p className="text-lg mb-5">
                4.3 Upon termination of the Agreement or your participation in the American Express Card
                Acceptance Services, you and your Sub-Merchants shall remove American Express Brand
                Marks
                from wherever such Marks may be displayed, including your website and the websites of
                your
                Sub-Merchants.
            </p>

            <p className="text-lg mb-5">
                5. American Express Card Acceptance Requirements. If the individual Sub-Merchant meet
                the
                criteria below and elect to accept American Express Transactions, we will provide
                American
                Express Card Acceptance Services to you, with respect to the individual Sub-Merchant,
                under
                the terms and settlement time frames provided in the Agreement.
            </p>

            <p className="text-lg mb-5">
                5.1. To qualify for the American Express Card Acceptance Services, the individual
                Sub-Merchant must meet the following criteria: (a) Sub-Merchant’s total annual American
                Express volume is less than $1,000,000; (b) the individual Sub-Merchant business is not
                of a
                merchant category type prohibited by American Express; and (c) the individual
                Sub-Merchant
                is not a franchisee of any franchise excluded by American Express from eligibility for
                the
                American Express Card Acceptance.
            </p>

            <p className="text-lg mb-5">
                5.2. After initial qualification, the individual Sub-Merchant must continue to meet
                American
                Express’ criteria for the American Express Card Acceptance. Currently, these criteria
                (each,
                a Continuing Qualification Threshold) are: (a) the total volume of American Express Card
                Transactions in any rolling 12 month period for all the individual Sub-Merchant’s
                Establishments is not more than $1,000,000, and (b) the total monthly volume of American
                Express Card Transactions for all the individual Sub-Merchant’s Establishments for any 3
                consecutive months does not exceed $100,000 per month.
            </p>

            <p className="text-lg mb-5">
                5.3. If the individual Sub-Merchant fails to meet the Continuing Qualification
                Thresholds,
                we may notify you of the individual Sub-Merchant’s conversion to a direct American
                Express
                Card acceptance relationship with American Express. In this event, you agree that once
                this
                conversion occurs (a) you and the individual Sub-Merchant will be bound by American
                Express’
                then-current Your Card Acceptance Guide with respect to American Express Transactions,
                (b)
                American Express will set pricing and other fees payable by you for American Express
                Card
                acceptance, and (c) you will no longer be able to participate in the American Express
                Card
                Acceptance for the individual Sub-Merchant through us. However, we may continue to
                provide
                Authorization and processing services, but not settlement services, to you or the
                individual
                Sub-Merchant for your American Express Card Transactions.
            </p>

            <p className="text-lg mb-5">
                5.4 You acknowledge that you and/or the individual Sub-Merchant may be converted to a
                direct
                Card relationship with American Express in the event that you become a High CV PSP. High
                CV
                PSP means a payment service First Data with either (i) greater than $250,000,000 in
                Charge
                Volume, from its Sub-Merchants in a rolling 12 month period; or (ii) greater than
                $25,000,000 in monthly Charge Volume from its Sub-Merchants in any 3 consecutive months.
                You
                agree and acknowledge that once this conversion occurs (a) you and the individual
                Sub-Merchant will be bound by American Express’ then-current Your Card Acceptance Guide
                with
                respect to American Express Transactions and (b) American Express will set pricing and
                other
                fees payable by you and the individual Sub-Merchant for American Express Card
                acceptance.
            </p>

            <p className="text-lg mb-5">
                5.5 You agree that you will only solicit prospective Sub-Merchants that meet all of the
                following criteria: (a) have Estimated Annual Charge Volume (ECV) of less than
                $1,000,000 in
                United States currency (USD) in the United States, (b) do not fall within any of the
                Prohibited Merchant Industries and Categories or any of the other excluded merchant
                categories listed in Prohibited Merchant Industries and Categories – Do Not Sign in the
                OptBlue Regulations, (c) are not on the Franchise Exclusion List provided in the OptBlue
                Regulations, and (d) transact in USD only (i.e., Sub-Merchant’s prices, goods and
                services
                to customers and payment to you are solely in U.S. dollars) and are located in the
                United
                States. You must accurately describe all Sub-Merchant criteria in any type of
                communications, publications, promotional or marketing materials, whether internal,
                external, oral or written. In the event you solicit a prospective merchant for Card
                acceptance and such merchant appears on the Franchise Exclusion List, you must refer
                such
                merchant to American Express’ “Want-to-Honor” Program at 1-855-TAKE-AXP, in the event
                that
                such merchant wants to apply for direct American Express Card acceptance.
            </p>

            <p className="text-lg mb-5">
                6. Fees for American Express Card Acceptance Services. The fees related to the American
                Express Card Acceptance Services will be interchange and all American Express Card fees
                on a
                straight pass-through basis plus $0.05 per transaction and 0.20% of transaction volume.
            </p>

            <p className="text-lg mb-5">
                7. American Express Transaction Data.
            </p>
            <p className="text-lg mb-5">
                7.1 The American Express Transaction Data you are required to collect in connection with
                a
                Transaction must be provided directly to you or a Sub-Merchant by the American Express
                Card
                Member. You must not accept American Express Transaction Data from, nor are you
                permitted to
                provide American Express Transaction Data to, any third parties other than your covered
                parties (as defined in the Data Security Operating Policy). If you fail to comply with
                this
                requirement, in addition to other rights and remedies regarding “monitoring,” you may be
                charged a fee as indicated in the American Express Program Pricing Guide (available at
                www.businesstrack.com), and we may suspend Card acceptance privileges at your
                Establishments
                or terminate this Schedule. For Card Member Transactions involving payment or “e-wallet”
                accounts (which Card Member created by providing their information when the account was
                established), the necessary Amex Transaction Data has already been provided directly by
                the
                Card Member, and you are not required to have the Card Member re-enter the Amex
                Transaction
                Data.
            </p>


            <p className="text-lg mb-5">
                7.2 You must provide the names of the owner(s) of each Sub-Merchant who will be
                transacting
                on the American Express Network to pursuant to the terms of the OptBlue Regulations.
            </p>

            <p className="text-lg mb-5">
                7.3 You must comply with, and ensure that your Sub-Merchants comply with, the American
                Express data security policy for Merchants found in the Amex Guide (DSR) and the Payment
                Card Industry Data Security Standard (PCI DSS) (available at
                www.pcisecuritystandards.org).
            </p>


            <p className="text-lg mb-5">
                7.4 You must report all instances of a Data Incident, as defined in the Amex Guide,
                immediately to Sub-Merchant after discovery of the incident.
            </p>

            <p className="text-lg mb-5">
                8. Disclosure and Use of Data Collected Under this Schedule. We may disclose to American
                Express all data and information you provide to us and that we collect as part of
                performing
                any Amex Service or any other Service related to your American Express Card Transactions
                (Collected Data). American Express may use and share Collected Data (a) to screen and/or
                monitor you in connection with Card marketing and administrative purposes, (b) to
                perform
                its responsibilities in connection with your acceptance of American Express Cards, (c)
                to
                promote the American Express Network, (d) to perform analytics and create reports, and
                (e)
                for any other business purpose, including marketing, as permitted by Applicable Law.
                American Express uses reasonable administrative, technical, and physical security
                measures
                to protect your information, consistent with the sensitivity of the information. You
                must
                provide an express disclosure to your Sub-Merchants of such possible use by American
                Express.
            </p>

            <p className="text-lg mb-5">
                9. Consent for American Express to Contact You by Phone, e-Mail, Text, or Fax. American
                Express may use the information you provide us (or that you update from time to time) to
                call you or send you communications or materials via email, text, fax, or other
                electronic
                means about American Express Card Acceptance Services and resources available to you.
                You
                consent to receive auto-dialed, automated, or pre-recorded calls or communications
                (including text messages) at the telephone number(s) you have provided. If you provide a
                fax
                number, you consent to receive fax communications from American Express. You acknowledge
                that by giving these consents, the calls made to you or the communications sent to you
                by
                American Express may be subject to charges or fees by your telecommunications or other
                applicable service First Data, and you agree that any charges or fees are your
                responsibility to pay. You also acknowledge that these consents are not a condition of
                receiving American Express Card Acceptance Services.
            </p>

            <p className="text-lg mb-5">
                10. Opt-Out. You may opt out of receiving marketing-related communications and materials
                from American Express by calling First Data’s customer service number provided by us. If
                you
                have opted out, you may still receive messages or communications from American Express
                related to important information about the American Express Card Acceptance Services or
                other American Express products, services, and resources available to you.
            </p>

            <p className="text-lg mb-5">
                11. No Assignment of Payments. You agree not to assign to any third party any payments
                due
                to you under this Schedule as the result of American Express Card Transactions, and all
                indebtedness arising from Charges will be for bona fide sales of goods and services (or
                both) at your Establishments free of liens, claims, and encumbrances (other than
                ordinary
                sales taxes). You may, however, sell and assign future Transaction receivables to First
                Data
                or to any other funding source that partners with First Data.
            </p>

            <p className="text-lg mb-5">
                12. Third Party Beneficiary Rights. American Express is a direct and intended third
                party
                beneficiary of the Schedule (including these Amex Terms) and may enforce any terms of
                this
                Schedule that apply to American Express, including American Express Card acceptance and
                transaction processing, directly against you.
            </p>

            <p className="text-lg mb-5">
                13. Your Right to Opt Out of American Express Card Acceptance. You may opt out of
                accepting
                American Express Cards at any time without affecting your right to accept any other
                payment
                type First Data supports.
            </p>
            <p className="text-lg mb-5">
                14. Collections from American Express Card Members. You may not bill or collect from any
                American Express Card Member for any purchase or payment on the American Express Card
                unless
                Chargeback has been exercised, you have fully paid for the Charge, and you otherwise
                have
                the right to do so.
            </p>

            <p className="text-lg mb-5">
                15. American Express Excessive Disputes. You may be subject to various fees and
                assessments
                as set forth on your Fee Schedule or in the American Express Program Pricing Guide,
                including fees for excessive disputes. Some fees and assessments are for special
                products or
                services, while others may be applied based upon non-compliance with American Express
                policies and procedures. Many non-compliance fees and assessments can be avoided by
                correcting the actions that are causing the non-compliance.
            </p>

            <p className="text-lg mb-5">
                16. Sub-Merchant Processing Agreement. You represent and warrant that, to the extent the
                Sub-Merchant wishes to use the American Express Card Acceptance Services, each
                Sub-Merchant
                executes the American Express Card Acceptance Schedule in the form attached as Appendix
                3 to
                the Sub-Merchant Processing Agreement. You also acknowledge that you are responsible for
                Your Sub-Merchant’s use or misuse of the American Express Card Acceptance Services under
                this Schedule.
            </p>

            <p className="text-lg mb-5">
                17. Survival. The provisions of the Schedule that by their terms require continuing
                performance to honor the obligations herein shall survive any termination or expiration
                of
                the Schedule, including your obligation to comply with Amex Rules (with respect to
                transactions occurring during the term of the Schedule and during the Transition
                Period):
                Dispute Resolution; and Third Party Beneficiary.
            </p>

            <p className="text-lg mb-5">
                18. Third Party Beneficiary. American Express is a third party beneficiary of the
                Schedule
                with the right to enforce all terms of the Schedule directly against Payment
                Facilitator.
                Except as provided in the foregoing sentence, the Schedule is entered into solely
                between,
                and may be enforced only by, First Data and Payment Facilitator, and the Schedule shall
                not
                be deemed to create any rights in third parties, including suppliers and customers of a
                party, or to create any obligations of a party to any such third parties.
            </p>

            <p className="text-lg mb-5">
                19. Counterparts. This Schedule may be executed in counterparts and each counterpart
                shall
                be deemed an original hereof.
            </p>

            <p className="text-lg mb-5">
                20. Agreement Confirmation. Except as otherwise amended hereby, the Agreement is hereby
                ratified in all respects and shall remain in full force and effect.
            </p>

        </div>
    )
}